import { WeaveCopilotSource } from './types';

export const WEAVE_COPILOT_ACTIONS = {
  openButton: 'open-button',
  closeButton: 'close-button',
  minimizeButton: 'minimize-button',
  popoutButton: 'popout-button',
  sendButton: 'send-button',
  feedbackPositive: 'feedback-positive',
  feedbackNegative: 'feedback-negative',
};

const TRACKING_PREFIX = 'weave-copilot';

export const getWeaveCopilotTrackingId = ({ source, action }: { source: WeaveCopilotSource; action: string }) => {
  return [TRACKING_PREFIX, source, action].join(':');
};
